import {Injectable} from "@angular/core";
import {Subject} from "rxjs";

@Injectable()
export class GameInput {
  paused = false;

  keys = new Subject<KeyboardEvent>();
  keysUp = new Subject<KeyboardEvent>();

  onKey(ev: KeyboardEvent): void {
    if (this.paused) return;
    this.keys.next(ev);
  }

  onKeyUp(ev: KeyboardEvent): void {
    if (this.paused) return;
    this.keysUp.next(ev);
  }

  stop(ev: KeyboardEvent): void {
    ev.stopImmediatePropagation();
    ev.stopPropagation();
    ev.preventDefault();
  }
}
